import React, { Component } from 'react'
import Modal from 'react-modal'
import ParentLoanModalUI from './ParentLoanModalUI'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'


class ParentLoanModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      submitted: false,
      parentLoanId: null,
    }
  }

  render() {
    return (
      <ParentLoanModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        onSubmit={this.onSubmit}
        onCancelClick={this.onCancelClick}
        parentLoanId={this.state.parentLoanId}
        onParentLoanIdChange={(event) => { this.setState({ parentLoanId: event.target.value }) }}
        parentLoanIdError={this.state.parentLoanIdError}
        setParentLoanIdError={(error) => { this.setState({ parentLoanIdError: error }) }}
        loanList={this.props.loanList}
      />
    )
  }

  onCancelClick = () => {
    this.setState({
      submitted: false, successMsg: null, errorList: null,
      parentLoanIdError: null,
    })
    this.props.onCancelClick()
  }

  componentDidMount() {
    Modal.setAppElement('body')
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted) return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/parentLoan`,
      this.onSubmitCallback, {
      parentLoanId: this.state.parentLoanId,
    })
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({ successMsg: null })
        this.props.onCancelClick()
        this.props.onRefreshClick()
      }, 1000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default ParentLoanModalSF
